/**
 * These keys are shared-secrets between accounts that are saved by the generating or receiving account.
 */

import { CryptoContext } from '../base';
import { SharedSecretConfigDumpArgs, SharedSecretConfigLoadArgs } from './args';
import { SharedSecretConfigV1 } from './v1';
import { CU_PQC_ML } from '../feature';

export let SHARED_SECRET_CRYPTO_CONTEXT = new CryptoContext<
  SharedSecretConfigLoadArgs,
  SharedSecretConfigDumpArgs
>([new SharedSecretConfigV1(CU_PQC_ML)]);
